import { useState } from 'react';
import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';
import { generatePath, useNavigate } from 'react-router-dom';
import { faHandBackPointUp } from '@fortawesome/pro-solid-svg-icons/faHandBackPointUp';
import { faXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Routes } from '../../Routes';
import { Button, ButtonType } from '../Button';

export const ApplyToJobsWidget = (): JSX.Element | null => {
  const { t } = useSharedTranslation(namespaces.caregiver);
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(true);

  const handleJobBoardClick = (): void => {
    navigate(generatePath(Routes.sitter.jobBoard));
  };

  const handleClose = (): void => {
    setIsVisible(false);
  };

  if (!isVisible) {
    return null; // Don't render anything if the widget is hidden
  }

  const title = t('components.applyToJobsWidget.title');
  const descriptionStart = t('components.applyToJobsWidget.descriptionStart');
  const descriptionLinkText = t('components.applyToJobsWidget.descriptionLinkText');
  const descriptionEnd = t('components.applyToJobsWidget.descriptionEnd');

  return (
    <div className='relative px-4 place-content-center rounded-2xl border-2 mb-10 border-gray-300 group w-full h-full'>
      <Button
        aria-label='Close'
        className='absolute top-2 right-4 text-gray-600 hover:text-gray-800'
        onClick={handleClose}
        buttonType={ButtonType.tertiary}
      >
        <FontAwesomeIcon icon={faXmark} className='text-lg text-gray-400' />
      </Button>
      <div className='block mb-3 mt-4'>
        <FontAwesomeIcon icon={faHandBackPointUp} className='mr-2 text-2xl text-honey ' />
        <span className='mt-1 font-bold text-base'>{title}</span>
      </div>
      <div className='block text-sm mb-3'>
        {descriptionStart}
        <Button
          className='text-blue-500 cursor-pointer !py-0'
          onClick={handleJobBoardClick}
          buttonType={ButtonType.tertiary}
        >
          {descriptionLinkText}
        </Button>
        {descriptionEnd}
      </div>
    </div>
  );
};
